import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl } from '@angular/forms';
import { BuroService } from '../../../core/service/app/buro.service';
import { CommerceService } from '../../../core/service/app/commerce.service';

@Component({
  selector: 'app-person-buro-form',
  templateUrl: './person-buro-form.component.html',
  styleUrls: ['./person-buro-form.component.scss']
})
export class PersonBuroFormComponent extends FormBaseComponent<any> implements OnInit {

  @Output()
  OnComplete = new EventEmitter<any>();

  person: any;
  constructor(private commerceService: CommerceService, private buroService: BuroService) {
    super();


  }

  ngOnInit() {
    this.init();

      this.commerceService.dataSub
      .delay(1000)
      .subscribe(x => {
        if (x.general) {
          if (x.general.personPhysical) {
            if (x.general.personPhysical.contact) {
              if (this.form) {
                this.form.patchValue({
                  name: x.general.personPhysical.contact.name || '',
                  lastNameF: x.general.personPhysical.contact.lastNamePaternal || '',
                  lastNameM: x.general.personPhysical.contact.lastNameMaternal || '',
                  postalCode: x.general.postalCode || 0,
                  address: x.general.street || '',
                });
              }

            }
          }
        }
      })

  }

  template() {
    this.form.addControl('name', new FormControl('EXPEDIENTE PRUEBA'));
    this.form.addControl('lastNameF', new FormControl('COPPEL'));
    this.form.addControl('lastNameM', new FormControl('PRIMER'));
    this.form.addControl('postalCode', new FormControl('81000'));
    this.form.addControl('address', new FormControl('JOSE MARIA MOR NO DE DIC 2205'));

    this.form.addControl('autoCredit', new FormControl(false));
    this.form.addControl('hipoCredit', new FormControl(false));
    this.form.addControl('cardCredit', new FormControl(false));
    this.form.addControl('cardCreditNum', new FormControl());
  }

  verification() {
    this.buroService.verification(this.form.value)
      .then(data => {
        this.toggle();
        this.onComplete.emit({});
      })
      .catch(error => {
        this.onComplete.emit({});
      })
  }



}



// WEBPACK FOOTER //
// ./src/app/form/form/person-buro-form/person-buro-form.component.ts